import { Component, inject, OnDestroy } from '@angular/core';
import { LegalPagesService } from '../../services/legal-pages.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-terms-conditions',
  standalone: false,
  templateUrl: './terms-conditions.component.html',
  styleUrl: './terms-conditions.component.scss',
})
export class TermsConditionsComponent implements OnDestroy {
  private legalPagesService = inject(LegalPagesService);

  terms = '';

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.legalPagesService
      .getLegalHtmlPage('terms-conditions')
      .pipe(takeUntil(this.destroy$))
      .subscribe((text) => (this.terms = text));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
